import "core-js/modules/es.number.constructor.js";
//
//
//
//
//

export default {
  props: {
    position: String,
    digit: [String, Number]
  }
};